/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useEffect } from "react";
import Container from "../components/Container";
import NavigationHeader from "../components/NavigationHeader";
import { useStoredClientPersonalData } from "../lib/react-query/useStoredClientPersonalData";
import PersonalDataRequestForm from "../components/PersonalDataRequestForm";
import ClientPersonalData from "../components/client/ClientPersonalData";
import Button from "../components/ui/Button";
import { useQueryClient } from "@tanstack/react-query";
import Icon from "../components/ui/Icon";
import useWidgetCallbackParams from "../hooks/useWidgetCallbackParams";

const PersonalDataReport = () => {
  const { clearParams } = useWidgetCallbackParams();
  const queryClient = useQueryClient();
  const { data: personalData } = useStoredClientPersonalData();
  const handleLogout = () => {
    queryClient.setQueryData(["client_personal_data_stored"], null);
  };

  useEffect(() => {
    clearParams();
  }, [clearParams])

  return (
    <Container>
      <NavigationHeader
        title="GDPR data"
        back={-1}
        rightContent={
          personalData && (
            <Button
              onClick={handleLogout}
              variant="dangerOutline"
              icon={<Icon.LogOut color="danger" size={Icon.SIZE.SM} />}
              title="Logout from report"
            />
          )
        }
      />
      {!personalData && <PersonalDataRequestForm />}
      {personalData && <ClientPersonalData data={personalData} />}
    </Container>
  );
};

export default PersonalDataReport;
